/*
 * Des formats écrits une fois (chantier nettoyage-mcp, ticket 05) : un mois « AAAA-MM », que le
 * serveur et le MCP reconnaissent de la même façon ; un nombre écrit comme on l'écrit en
 * français, pour que le serveur, l'app et le MCP disent tous « 20 000 » ; les caractères de
 * contrôle (chantier nettoyage-chemin, ticket 05). Sans dépendance : l'entrée « . » du paquet,
 * l'app peut l'importer.
 */
/**
 * **Les caractères de contrôle**, définis ici seulement : de U+0000 à U+001F (le retour chariot, le
 * saut de ligne, la tabulation compris) et U+007F. Le lien les refuse (`champLien`, `champs.ts`) ;
 * le MCP les retire d'un titre que le serveur lui nomme (`assainirTache`). Sans drapeau `g` :
 * `test` ne garde rien d'un appel à l'autre.
 */
export const CARACTERES_DE_CONTROLE = /[\u0000-\u001f\u007f]/;
/** Le texte, chaque caractère de contrôle remplacé (par une espace, par défaut). */
export function sansCaracteresDeControle(texte, par = ' ') {
    return texte.replace(new RegExp(CARACTERES_DE_CONTROLE.source, 'g'), par);
}
/** « 2026-10 » est un mois ; « 2026-13 », « 2026-1 » ou « 2026-10-01 » n'en sont pas. */
export function moisValide(mois) {
    return /^\d{4}-(0[1-9]|1[0-2])$/.test(mois);
}
/** « 20 000 », « 1 000 000 » : un nombre, ses milliers séparés comme en français (`fr-FR`). */
export function direNombre(nombre) {
    return nombre.toLocaleString('fr-FR');
}
/**
 * Comparer sans tenir compte de la casse ni des accents : « photo » doit trouver
 * « Photo d'identité », et « echeance » doit trouver « échéance ». Sans ça, la recherche
 * echoue exactement sur les mots que l'utilisateur tape vite, sans accents. Une seule définition,
 * lue par la recherche du serveur et par les contacts du MCP (chantier claude-gestes-et-contacts, 02).
 */
export function sansAccent(texte) {
    return texte
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
}
